<div
  class="emperor-ui-tooltip-triangle"
  [ngStyle]="{ 'left.px': triangleLeft }"
></div>
<div aria-live="polite" [innerHTML]="data.message"></div>
